import { defaultPropertyConfig, status } from './common.js';
import requirement from './requirements.js'
import validator from './veriflcation';
import { addRequirements } from './requirements.js'
let globalRule = {
  isSoldOut: [
    { type: 'boolean', value: true, message: '该餐品已售罄' }
  ],
  isInServiceTime: [
    { type: 'boolean', value: false, message: '不在营业时间' }
  ],
  hasInventory: [
    { 
      validator: (rule, value, source, callback) => {
        if (value) {
          if (source.hasInventory && source.inventoryNum === 0 || source.num > source.inventoryNum) {
            callback(new Error('该餐品库存不足'));
          } else {
            callback();
          }
        }
      }
    }
  ]
}

export default {
  /**
    * 添加餐品组合数据
    * @params {object} foodCombination 当前餐品组合数据
    * @params {object} selectCombination 选择的餐品组合id
  */
  addCombination(foodCombination, index, num, selectCombination = 0) {
    let combination;
    if (Array.isArray(foodCombination)) {
      combination = foodCombination.products.findIndex((item) => item.combinationTypeKey === selectCombination );
      if (combination === -1) {
        return status.combination;
      }
      combination = foodCombination.products[combination];
    } else {
      combination = foodCombination
    }
    const rules = globalRule;
    const error = validator(rules, {
      isInServiceTime: combination.isInServiceTime,
      isSoldOut: combination.isSoldOut,
      hasInventory: combination.hasInventory,
      inventoryNum: combination.inventoryNum,
      num
    });
    if (error.length) {
      return {
        status: false,
        message: error[0]
      };
    }
    const productsCombination = {
      isCombination: true,
      combinationId: combination.productId,
      isScore: combination.isScore || false,
      num,
      pid: combination.product.uid,
      price: combination.product.price,
      name: combination.product.name,
      nameEn: combination.product.nameEn || combination.product.name,
      typeId: combination.product.smallTypeId || combination.product.bigTypeId
    };
    const config = {};
    let path = '_products[' + index + ']'
    defaultPropertyConfig.forEach((key) => {
      if (combination.product[key] !== undefined) {
        config[key] = combination.product[key];
      }
    });
    productsCombination._means = {  config, foodCombination, getPath: path };
    // Object.defineProperty(productsCombination, '_means', {
    //   value: { config, foodCombination, getPath: path, }
    // });
    // Object.defineProperty(productsCombination, '_combination', {
    //   value: foodCombination
    // });
    if (combination.product.hasOwnProperty('requirements') && combination.product.requirements.length) { // 如果有特殊要求
      productsCombination.listRequirements = [];
      productsCombination.listRequirements._means = { getPath: path + '.listRequirements' };
      // Object.defineProperty(productsCombination.listRequirements, '_means', {
      //   value: { getPath: path + '.listRequirements' }
      // });
      const requirements = addRequirements(
        combination.product.requirements,
        productsCombination.listRequirements,
        1
      )
      if (requirements) {
        productsCombination.listRequirements.push(requirements);
      }
      Object.defineProperty(productsCombination.listRequirements, '_requirements', {
        value: combination.product.requirements
      });
    }
    return {
      status: true,
      products: productsCombination
    }
  }
}


// WEBPACK FOOTER //
// ./../../plugins/cart/combination.js